import { render, staticRenderFns } from "./TextareaTab.vue?vue&type=template&id=47eb5140&"
import script from "./TextareaTab.vue?vue&type=script&lang=js&"
export * from "./TextareaTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports